import {
    Box,
    Button,
    Flex,
    IconButton,
    Table,
    TableContainer,
    Tbody,
    Td,
    Text,
    Th,
    Thead,
    Tooltip,
    Tr,
    useToast,
    useBreakpointValue,
    Grid,
    Popover,
    PopoverTrigger,
    Portal,
    PopoverContent,
    PopoverArrow,
    PopoverCloseButton,
    PopoverBody,
    VStack,
} from "@chakra-ui/react";
import CommonModal from "components/common/CommonModal/CommonModal";
import { Paginationlimit } from "components/common/functions/variable";
import Pagination from "components/common/Pagination/Pagination";
import TableLoader from "components/common/TableLoader/TableLoader";
import React, { useEffect, useState } from "react";
import { HiOutlineFilter, HiOutlineRefresh } from "react-icons/hi";
import { appRequest } from "routes";
import { EditIcon } from "@chakra-ui/icons";
import SearchBox from "components/layouts/MainWindow/Navbar/SearchBox";
import PaymentCardView from "./PaymentCardView";
import CreatePayment from "./CreatePayment";
import debounce from "lodash.debounce";
import CustomSelect from "../../common/CustomSelect/CustomSelect";

export default function PaymentTable(): JSX.Element {
    const initialDateRange = {
        startDate: new Date(new Date().setDate(new Date().getDate() - 7)),
        endDate: new Date(),
        key: "selection",
    };

    const [dateRange, setDateRange] = useState<any>(initialDateRange);
    const { startDate, endDate } = dateRange;
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [bankTransfers, setBankTransfers] = useState<any[]>([]);
    const [bppIds, setBppIds] = useState<any[]>([]);
    const [bppIdFilter, setBppIdFilter] = useState<any>("");
    const [editData, setEditData] = useState({});
    const [editingIndex, setEditingIndex] = useState(-1);
    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState(""); // New state for search query
    const toast = useToast();

    const isMobileView = useBreakpointValue({ base: true, md: false });

    const getAllBankTransfers = async () => {
        try {
            setLoading(true);
            let page = currentPage;
            let limit = Paginationlimit;
            let providerName = bppIdFilter ? bppIdFilter : "";
            const request: any = {
                limit,
                page,
                providerName,
                ...(searchQuery.trim() && { search: searchQuery.trim() }),
            };
            const response: any = await appRequest("metro", "getAllBankTransfers", request);

            if (response.status === "success") {
                console.log("get all Bank Transfers response", response)
                setTotalPages(response?.totalPages || 0);
                setBankTransfers(response?.bankTransfers || []);
            }
        } catch (error: any) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    const getBppIdsInTransactions = async () => {
        try {
            const response: any = await appRequest("metro", "allBppIdsInTransactions", {});

            if (response.status === "success") {
                console.log("get all bpp ids response", response)
                setBppIds(response.bppIds || []);
            }
        } catch (error: any) {
            console.error("Error fetching providers:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getAllBankTransfers();
    }, [currentPage, searchQuery, bppIdFilter]);

    useEffect(() => {
        // getCities();
        getBppIdsInTransactions();
    }, []);

    const bppIdOptions = bppIds.map((bppId: any) => ({
        value: bppId._id,
        label: bppId._id,
    }));

    const handleFilterChange = (e: any) => {
        if (e && e.value) {
            setBppIdFilter(e.value);
        } else {
            setBppIdFilter(null); // or any default value you'd like to set
        }
    };

    const handleSearch = debounce((query: string) => {
        setSearchQuery(query);
        setCurrentPage(1); // Reset to the first page when searching
    }, 300); // Debounce for 300ms

    const handlePageChange = (page: any) => {
        setCurrentPage(page.selected + 1);
    };

    const handleEdit = (item: any) => {
        setEditData(item);
        setIsCreateModalOpen(true);
    };

    const handleRefreshAllData = () => {
        setDateRange(initialDateRange);
        setSearchQuery("");
        setBppIdFilter("");
        getAllBankTransfers();
        getBppIdsInTransactions();
    };

    return (
        <>
            <Box
                p={5}
                rounded={"lg"}
                bg={"white"}
                shadow={"rgb(0 0 0 / 20%) 0px 0px 11px"}
            >
                <Flex
                    justify={"space-between"}
                    mb={2}
                    direction={{ base: "column", md: "row" }}
                >
                    <Text fontWeight={700} fontSize={"xl"} color={"teal.400"} mb={2}>
                        All Payments
                    </Text>

                    <Flex gap={2} justify={"end"} direction={{ base: "column", md: "row" }}>
                        <SearchBox onSearch={handleSearch} />
                        <Button
                            onClick={() => {
                                setIsCreateModalOpen(true);
                            }}
                            colorScheme="teal"
                            size={{ base: "sm", md: "md" }}
                        >
                            ADD
                        </Button>

                        <Grid templateColumns="1fr 1fr" gap={2} alignItems={'center'}>
                            <Popover>
                                <PopoverTrigger>
                                    <IconButton
                                        aria-label="Filter"
                                        colorScheme="teal"
                                        icon={<HiOutlineFilter />}
                                        size={{ base: "sm", md: "md" }}
                                    />
                                </PopoverTrigger>
                                <Portal>
                                    <PopoverContent shadow={"lg"} borderWidth={2}>
                                        <PopoverArrow />
                                        <PopoverCloseButton />
                                        <PopoverBody p={5}>
                                            <VStack spacing={6} mt={2}>
                                                {/* <CustomSelect
                                                    options={cityNames}
                                                    label={"Filter By City"}
                                                    onChange={handleCityFilterChange}
                                                // width={selectWidth}
                                                /> */}
                                                <CustomSelect
                                                    options={bppIdOptions}
                                                    label={"Providers"}
                                                    onChange={handleFilterChange}
                                                />
                                            </VStack>
                                        </PopoverBody>
                                    </PopoverContent>
                                </Portal>
                            </Popover>
                            <Tooltip label="Refresh" hasArrow>
                                <IconButton
                                    aria-label="Refresh"
                                    icon={<HiOutlineRefresh />}
                                    colorScheme="teal"
                                    variant="outline"
                                    borderWidth={2}
                                    _hover={{ bg: "teal.100" }}
                                    onClick={handleRefreshAllData}
                                    size={{ base: "sm", md: "md" }}
                                />
                            </Tooltip>
                        </Grid>
                    </Flex>
                    {/* </Flex> */}
                </Flex>

                {isMobileView ? (
                    <PaymentCardView data={bankTransfers} handleEdit={handleEdit} />
                ) : (
                    <>
                        <TableContainer className="customScrollBar" pb={2}>
                            <Table>
                                <Thead>
                                    <Tr>
                                        <Th>Provider</Th>
                                        <Th>Transaction No.</Th>
                                        <Th>Payment</Th>
                                    </Tr>
                                </Thead>
                                <TableLoader
                                    noDataText="No Cities  Available"
                                    show={bankTransfers?.length}
                                    loader={loading}
                                >
                                    <Tbody>
                                        {bankTransfers?.map((bankTransfer, index) => (
                                            <Tr
                                                key={bankTransfer._id}
                                                _hover={{ bg: "gray.100" }}
                                                className={JSON.stringify(index)}
                                                cursor={"default"}
                                            // onClick={() => {
                                            //     handleRowClick(ad._id);
                                            // }}
                                            >
                                                <Td
                                                // onClick={(e) => {
                                                //     if (editingIndex !== index) {
                                                //     } else {
                                                //         e.stopPropagation();
                                                //     }
                                                // }}
                                                // cursor={editingIndex !== index ? "pointer" : "default"}
                                                >
                                                    <Text fontWeight={500}>{bankTransfer.bpp_id}</Text>
                                                </Td>
                                                <Td>
                                                    <Text isTruncated maxW={"10rem"}>
                                                        {bankTransfer.utr}
                                                    </Text>
                                                </Td>
                                                <Td>
                                                    <Text maxW={"10rem"}>
                                                        ₹ {bankTransfer.amount}
                                                    </Text>
                                                </Td>
                                            </Tr>
                                        ))}
                                    </Tbody>
                                </TableLoader>
                            </Table>
                        </TableContainer>
                        <Pagination
                            currentPage={currentPage}
                            totalPages={totalPages}
                            handlePageChange={handlePageChange}
                        />
                    </>
                )}
                <CommonModal
                    header={editingIndex >= 0 ? "Edit Payment" : "Add Payment"}
                    width={{ base: "100vw", md: "60vw" }}
                    animate={true}
                    isOpen={isCreateModalOpen}
                    onClose={() => {
                        setIsCreateModalOpen(false);
                        setEditData({});
                        setEditingIndex(-1);
                    }}
                    body={
                        <Box>
                            <CreatePayment
                                bppIds={bppIds}
                                setIsCreateModalOpen={setIsCreateModalOpen}
                                handleRefreshAllData={handleRefreshAllData}
                                initialData={editData} // Pass editData here
                            />
                        </Box>
                    }
                />

            </Box>
        </>
    );
}
